import { useState, type FormEvent } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { homePathForRole } from "../lib/routes";
import { ApiError } from "../api/client";

export function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("pat@royalheights.ca");
  const [password, setPassword] = useState("RoyalHeights123!");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (user) {
    return <Navigate to={homePathForRole(user.role)} replace />;
  }

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const u = await login(email, password);
      const fromState = (location.state as { from?: string } | null)?.from;
      const target = fromState && fromState !== "/login" ? fromState : homePathForRole(u.role);
      navigate(target, { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError("That email and password did not match. Please try again.");
      } else {
        setError("Could not sign in. Please try again in a moment.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="center-screen">
      <form className="auth-card" onSubmit={onSubmit} noValidate>
        <div className="brand-stack">
          <div className="logo">RH</div>
          <h1>Royal Heights</h1>
          <p className="sub">Property Management</p>
        </div>
        <label className="field">
          <span>Email</span>
          <input
            type="email"
            inputMode="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="field">
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && (
          <div className="warn-box" role="alert">
            <strong>Sign-in failed</strong>
            {error}
          </div>
        )}
        <button
          type="submit"
          className="btn btn-primary btn-block btn-xl"
          disabled={submitting}
        >
          {submitting ? "Signing in…" : "Log In"}
        </button>
      </form>
    </div>
  );
}
